@import '../../../../style/lib/scss';
@import '../../../../style/src/typography/mixins';

@mixin fullscreen-modal {
	border-radius: 0;
	height: 100%;
	max-height: none;
	min-height: 0;
	width: 100%;
}

.zds-modal {
	@include zds-typography('body');

	align-items: center;
	bottom: 0;
	display: flex;
	justify-content: center;
	left: 0;
	pointer-events: none;
	position: fixed;
	top: 0;
	transition:
		visibility 0s,
		opacity var(--zds-transition-md);
	width: 100%;

	&:not(&--open) {
		opacity: 0;
		transition:
			visibility 0s 300ms,
			opacity var(--zds-transition-md);
		visibility: hidden;
	}

	&--storybook {
		position: absolute;
		width: 100%;
	}

	&__wrapper {
		background: var(--zds-modal-background);
		border-radius: var(--zds-modal-border-radius);
		box-shadow: 0 0 8px 5px rgb(0 0 0 / 15%);
		display: flex;
		flex-direction: column;
		max-height: min(var(--zds-modal-max-height), calc(100% - var(--zds-space-6)));
		min-height: 100px;
		overflow: hidden;
		pointer-events: auto;
		width: min(var(--zds-modal-width), calc(100% - var(--zds-space-6)));
	}

	&--fullscreen &__wrapper {
		@include fullscreen-modal;
	}

	@each $breakpoint in map-keys($zds-breakpoints) {
		@include zds-media-breakpoint-down($breakpoint) {
			&--fullscreen-#{$breakpoint}-down &__wrapper {
				@include fullscreen-modal;
			}
		}
	}

	&__header,
	&__body,
	&__footer {
		padding: var(--zds-modal-inset);
	}

	&__header,
	&__footer {
		align-items: center;
		display: flex;
		flex-shrink: 0;
	}

	&__header {
		gap: var(--zds-space-6);
		justify-content: space-between;

		&-wrapper {
			flex-grow: 1;
		}

		&-start,
		&-end {
			display: flex;
		}
	}

	&__title {
		color: var(--zds-modal-header-color);
		font-family: var(--zds-modal-header-font-family);
		font-size: var(--zds-modal-header-font-size);
		font-weight: var(--zds-modal-header-font-weight);
		margin: 0;
		text-align: var(--zds-modal-header-text-align);

		&--start {
			text-align: start;
		}

		&--end {
			text-align: end;
		}
	}

	&__body {
		$scroll-shadow-top: inset 0 var(--zds-modal-scroll-shadow-offset-y) var(--zds-modal-scroll-shadow-blur-radius)
			var(--zds-modal-scroll-shadow-spread-radius) var(--zds-modal-scroll-shadow-color);
		$scroll-shadow-bottom: inset 0 calc(-1 * var(--zds-modal-scroll-shadow-offset-y))
			var(--zds-modal-scroll-shadow-blur-radius) var(--zds-modal-scroll-shadow-spread-radius)
			var(--zds-modal-scroll-shadow-color);

		flex-grow: 1;
		min-height: 100px;
		overflow: auto;

		&.has-shadow {
			box-shadow: $scroll-shadow-top, $scroll-shadow-bottom;
		}

		&--is-scrolled-to-top.has-shadow {
			box-shadow: $scroll-shadow-bottom;
		}

		&--is-scrolled-to-bottom.has-shadow {
			box-shadow: $scroll-shadow-top;
		}
	}

	&__footer {
		justify-content: end;
	}

	&__divider {
		margin: 0;
	}
}

/* Mobile styling, should be active on screens with either small width or small height */

@mixin zds-modal-mobile-styling {
	.zds-modal {
		&__header-start {
			margin-right: var(--zds-space-2);
		}

		&__header-end {
			margin-left: var(--zds-space-2);
		}
	}
}

@include zds-media-breakpoint-down('xs') {
	@include zds-modal-mobile-styling;
}

@media (height <= 600px) {
	@include zds-modal-mobile-styling;

	// On small heights, cap the inset token at 16px
	.zds-modal {
		&__header,
		&__body,
		&__footer {
			padding: min(var(--zds-modal-inset), var(--zds-space-4));
		}
	}
}
